export default {
  path: '/orders',
  name: 'orders',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/orders/orders-create',
  children: [
    {
      path: 'orders-create',
      meta: { title: '采购开单', permission: 'orders-create' },
      component: () => import('@/views/sale/saleCreate/index'),
    },
    {
      path: 'orders-record',
      meta: { title: '销售记录', permission: 'orders-record' },
      component: () => import('@/views/sale/saleRecord/index'),
    },
    {
      path: 'orders-recordDetail',
      meta: { title: '销售记录详情', permission: 'orders-recordDetail' },
      component: () => import('@/views/sale/saleRecordDetail/index'),
    },
    {
      path: 'orders-return-create',
      meta: { title: '销售退货', permission: 'orders-return-create' },
      component: () => import('@/views/sale/saleReturnCreate/index'),
    },
    {
      path: 'orders-return-record',
      meta: { title: '销售退货记录', permission: 'orders-return-record' },
      component: () => import('@/views/sale/saleReturnRecord/index'),
    },
    {
      path: 'ordersReturnDetail',
      meta: { title: '退货记录详情', permission: 'ordersReturnDetail' },
      component: () => import('@/views/sale/saleReturnDetail/index'),
    },
  ],
}